export interface IMessageEditItem {
    id: string;
    companyId: string;
    date: number;
    title: string;
    content: string;
    userName: string;
    userCompanyName: string;
    userPicture: string;
    requiresReceiptIsRead: boolean;
    requiresReceipt: boolean;
    isRead: boolean;
}

export class MessageEditItem implements IMessageEditItem {
    id: string;
    companyId: string;
    date: number;
    title: string;
    content: string;
    userName: string;
    userCompanyName: string;
    userPicture: string;
    requiresReceiptIsRead: boolean;
    requiresReceipt: boolean;
    isRead: boolean;

    constructor();
    constructor(obj: IMessageEditItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.date = obj && obj.date || 0;
        this.title = obj && obj.title || "";
        this.content = obj && obj.content || "";
        this.userName = obj && obj.userName || "";
        this.userCompanyName = obj && obj.userCompanyName || "";
        this.userPicture = obj && obj.userPicture || "";
        this.requiresReceiptIsRead = obj && obj.requiresReceiptIsRead || false;
        this.requiresReceipt = obj && obj.requiresReceipt || false;
        this.isRead = obj && obj.isRead || false;
    }
}